export enum TherapyTypeTranslation {
  Unknown = 'general.therapy_type.unknown',
  Other = 'general.therapy_type.other',
  Immunobody = 'general.therapy_type.immunobody',
  Antibody = 'general.therapy_type.antibody',
  Radiation = 'general.therapy_type.radiation',
  Hormone = 'general.therapy_type.hormone',
  Chemo = 'general.therapy_type.chemo',
  Surgery = 'general.therapy_type.surgery'
}